var _G, _Defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
function SvgMessages(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 17",
    fill: "#0094FF",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#messages_svg__clip0_10427_5996)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M13.333.53H2.667A2.667 2.667 0 000 3.199v8a2.667 2.667 0 002.667 2.666H4.6l2.967 2.509a.667.667 0 00.862 0l2.971-2.509h1.933A2.667 2.667 0 0016 11.197v-8A2.667 2.667 0 0013.333.532zm1.334 10.667a1.333 1.333 0 01-1.334 1.334H11.4c-.315 0-.62.112-.86.315L8 14.991l-2.538-2.145a1.333 1.333 0 00-.862-.315H2.667a1.334 1.334 0 01-1.334-1.334v-8a1.333 1.333 0 011.334-1.333h10.666a1.333 1.333 0 011.334 1.334v8z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M4.667 5.198H8a.667.667 0 000-1.334H4.667a.667.667 0 000 1.334zM11.333 6.53H4.667a.667.667 0 000 1.334h6.666a.667.667 0 100-1.333zM11.333 9.198H4.667a.667.667 0 000 1.333h6.666a.667.667 0 000-1.333z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "messages_svg__clip0_10427_5996"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    transform: "translate(0 .53)",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgMessages;